import templatesTypes from '../../constants/templatesTypes'
export * from './create'
export * from './delete'
export * from './get'
export * from './getindex'
export * from './getxlsx'
export * from './publish'
export * from './trash'
export * from './unpublish'
export * from './update'

const set_template_errors = (messages) => {
  return {
    type: templatesTypes.set_errors,
    payload: messages
  }
}

const reset_template = () => {
  return {
    type: templatesTypes.reset_template
  }
}

const clear_template = () => {
  return {
    type: templatesTypes.clear_template
  }
}

export {
  set_template_errors,
  reset_template,
  clear_template
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/index.js